export default __webpack_public_path__ + "static/logo-bbd9169010597ffa28fa537b8bd3eab8.png";